import { Component, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserOrderModel } from 'src/app/nutrigenic/models/profile/user-order-model';
import { PlanService } from 'src/app/nutrigenic/services/plan/plan.service';
import { UserProfileService } from 'src/app/nutrigenic/services/profile/user-profile.service';
import { HomeService } from 'src/app/nutrigenic/services/home/home.service';
import { ResizeDetectionService } from 'src/app/nutrigenic/services/resize-detection.service';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { NgxSpinnerService } from 'ngx-spinner';
import { StripeService } from 'ngx-stripe';
import { StripeCardComponent } from 'ngx-stripe';
import { Appearance } from '@stripe/stripe-js';
import { Address } from 'src/app/nutrigenic/models/address-model';

@Component({
    selector: 'app-my-orders',
    templateUrl: './my-orders.component.html',
    styleUrls: ['./my-orders.component.scss']
})
export class MyOrdersComponent {

    userOrdersResult: any = {
        "total": 0,
        "per_page": 10,
        "last_page": 0,
        "data": [],
        "first_page_url": null,
        "last_page_url": null,
        "next_page_url": null,
        "prev_page_url": null,
        "current_page": 0
    };
    isTablet: boolean = false;
    isMobile: boolean = false;
    isDesktop: boolean = false;
    detailsPopUpVisibility: boolean = false;
    paymentPopUpVisibility: boolean = false;
    showCancelSubscriptionForm: boolean = false;
    pauseSubscriptionPopUpVisibility: boolean = false;
    loading: boolean = true;
    orderStatusList:any = [];
    stripeTest: FormGroup;
    cancellationForm: FormGroup;
    pauseSubscriptionForm: FormGroup;
    cancellationDates: any[] = [];
    pauseDates: any[] = [];
    filteredPauseDates: any[] = [];
    order:any = null;
    order_details:any = [];
    addons:any = [];
    to_pay:any;
    enableEditAddress: boolean;

    constructor(
        private userProfileService: UserProfileService,
        private sizedetection: ResizeDetectionService,
        private planService: PlanService,
        private fb: FormBuilder,
        private spinner: NgxSpinnerService,
        private router: Router,
        private stripeService: StripeService,
        private homeService: HomeService
    ) { }

    ngOnInit() {
        this.stripeTest = this.fb.group({
            name: ['', [Validators.required]]
        });
        this.cancellationForm = this.fb.group({
            cancelDate: ['', [Validators.required]],
            reason: ['', [Validators.required]]
        });
        this.pauseSubscriptionForm = this.fb.group({
            pauseFromDate: ['', [Validators.required]],
            pauseToDate: ['', [Validators.required]]
        });
        this.sizedetection.refreshSize();
        this.sizedetection.sizeCondition$.subscribe(data => {
            this.isDesktop = data.isDesktop;
            this.isTablet = data.isTablet;
            this.isMobile = data.isMobile;
        });

        // These should come from an api call to the back end
        this.orderStatusList = [
            {
                id: 1,
                text: 'Completed',
                icon: 'assets/images/checkmark-circle.svg',
                color: '#DFDFEF'
            },
            {
                id: 2,
                text: 'In Revision',
                icon: 'assets/images/alert.svg',
                color: '#FCDAB1'
            },
            {
                id: 4,
                text: 'Suspended',
                icon: 'assets/images/alert.svg',
                color: '#FCBBB1'
            },
            {
                id: 5,
                text: 'Active',
                icon: 'assets/images/workout-run.svg',
                color: '#CEF3DF'
            },
            {
                id: 7,
                text: 'Paused',
                icon: 'assets/images/pause-circle.svg',
                color: '#FCDAB1'
            },
            {
                id: 8,
                text: 'Canceled',
                icon: 'assets/images/alert.svg',
                color: '#FCBBB1'
            }
            
        ]

        this.getUserOrders();
    }

    previousOrders() {
        if(this.userOrdersResult.current_page > 1){
            this.getUserOrders(this.userOrdersResult.current_page - 1);
        }
    }

    nextOrders() {
        if(this.userOrdersResult.next_page_url != null){
            this.getUserOrders(this.userOrdersResult.current_page + 1);
        }
    }


    getUserOrders(myOrdersPage: number = 1){
        let userOrders: UserOrderModel[] = [];
        let userOrdersResultTmp = {
            "total": 0,
            "per_page": 10,
            "last_page": 0,
            "data": userOrders,
            "first_page_url": null,
            "last_page_url": null,
            "next_page_url": null,
            "prev_page_url": null,
            "current_page": 0
        };
        this.spinner.show();
        this.loading = true;
        this.userProfileService.getUserOrders(myOrdersPage).subscribe( {
            next : (response: any) => {
                response.body.data.forEach((item: any) => {

                    var userOrder = new UserOrderModel();
                    userOrder.id = item.id;
                    userOrder.order_type = item.order_type;
                    userOrder.order_num = item.order_num;
                    userOrder.order_date = userOrder.GetDate(new Date(item.order_date));
                    userOrder.discount_amount = parseFloat(parseFloat(item.discount_amount).toFixed(2));
                    userOrder.shipment_amount = parseFloat(parseFloat(item.shipment_amount).toFixed(2));
                    userOrder.sub_total = parseFloat(parseFloat(item.subtotal_amount).toFixed(2));
                    userOrder.total_amount = parseFloat(parseFloat(item.total_amount).toFixed(2));
                    userOrder.expert_id = item.expert_id;
                    userOrder.meals_per_day = item.meals_per_day;
                    userOrder.days_per_week = item.days_per_week;
                    userOrder.weeks = item.weeks;
                    userOrder.address = item.address;
                    userOrder.city = item.city;
                    userOrder.zip = item.zip;
                    userOrder.created_at = item.created_at;
                    userOrder.order_detail = item.order_details;
                    userOrder.status = item.status;
                    userOrder.to_pay = item.to_pay;
                    userOrder.weekly_prices = [];
                    userOrder.cancel_from = item.cancel_from ? this.formatDate(new Date(item.cancel_from)) : '';
                    userOrder.auto_renew = item.auto_renew;
                    userOrder.pause_from = item.pause_from ? this.formatDate(new Date(item.pause_from)) : '';
                    userOrder.pause_until = item.pause_until ? this.formatDate(new Date(item.pause_until)) : '';

                    userOrders.push(userOrder);
                });


                userOrders.forEach(order => {
                    let date = new Date(order.order_detail[0].delivery_date);
                    date.setDate(date.getDate() - 3);

                    let nowDate = new Date();
                    nowDate.setHours(0, 0, 0, 0); // Reset time to midnight
                    // DEBUG - force now date
                    // nowDate = new Date(2025,2,19);
                    // console.log('now2', new Date(now));

                    let order_detail_next = order.order_detail.filter((x:any)=>{
                        let deliveryDate = new Date(x.delivery_date);
                        deliveryDate.setDate(deliveryDate.getDate() - 3)
                        return deliveryDate.getTime() > nowDate.getTime()
                    });


                    if (order_detail_next.length > 0 && order.order_type !== 'expert') {
                        var edit_weeks = order_detail_next.filter((x:any)=>new Date(x.delivery_date).getTime() > date.getTime());
                        order.edit_week = edit_weeks[0].week;
                    } 
                });
                
                userOrders = userOrders.sort(function(a,b){
                    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
                });

                userOrdersResultTmp.data = userOrders;
                userOrdersResultTmp.total = response.body.total;
                userOrdersResultTmp.per_page = response.body.per_page;
                userOrdersResultTmp.last_page = response.body.last_page;
                userOrdersResultTmp.first_page_url = response.body.first_page_url;
                userOrdersResultTmp.last_page_url = response.body.last_page_url;
                userOrdersResultTmp.next_page_url = response.body.next_page_url;
                userOrdersResultTmp.prev_page_url = response.body.prev_page_url;
                userOrdersResultTmp.current_page =  response.body.current_page;
                this.userOrdersResult = userOrdersResultTmp;
                 

                this.loading = false;
                this.spinner.hide();
            }, 
            error: (error) => {
                console.error(error);
                this.spinner.hide();
                this.loading = false;
            }
        })
    }


    getOriginalWeekPrice(week: number){
        return this.order?.weekly_prices?.[week - 1]?.["original-price"];
    }

    getDiscountedWeekPrice(week: number){
        return this.order?.weekly_prices?.[week - 1]?.["discounted-price"];
    }

    getDiscountAppliedWeekPercentage(week: number){
        return this.order?.weekly_prices?.[week - 1]?.["discount-percentage"];
    }

    hasDiscountForWeek(week: number){
        return this.order?.weekly_prices?.[week - 1]?.["discount-percentage"] > 0;
    }

   
    

    private createCancelationDatesMenu(order_details: any[]) {
        this.cancellationDates = this.getDeliveryDatesBeginningWeek(order_details);
    }

    private createPauseDatesMenu(order_details: any[]) {
        this.pauseDates = this.getDeliveryDates(order_details);
        this.filteredPauseDates = this.pauseDates;
    }

    onPauseFromDateChange(selectedDate: string) {
        if (selectedDate) {
            const selectedDateObj = new Date(selectedDate);
            this.filteredPauseDates = this.pauseDates.filter(date => new Date(date.value) > selectedDateObj);
            this.pauseSubscriptionForm.get('pauseToDate')?.reset();
        } else {
            this.filteredPauseDates = this.pauseDates;
        }
    }


    private getDeliveryDates(order_details: any[]) {
        const now = new Date();
        now.setDate(now.getDate() + 4); // to select the dates that are before the next payment
        const seen = new Set<string>();
        const dates: any[] = [];
        order_details.forEach((item: any) => {
            if(item.week < 3) return; // you can only cancel/pause from the 3rd week onwards
            item.details.forEach((detail: any) => {
                const deliveryDate = new Date(detail.delivery_date);
                if(deliveryDate > now) {
                    const dateStr = deliveryDate.toISOString();
                    if(!seen.has(dateStr)) {
                        seen.add(dateStr);
                        dates.push({ label: deliveryDate.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' }), value: dateStr });
                    }
                }
            });
        });
        return dates;
    }


    private getDeliveryDatesBeginningWeek(order_details: any[]) {
        const now = new Date();
        now.setDate(now.getDate() + 4); // to select the dates that are before the next payment
        return order_details
            .map((item: any) => {
                if(item.week < 3) return null; // you can only cancel/pause from the 3rd week onwards
                const deliveryDate = new Date(item.details[0].delivery_date);
                return deliveryDate > now ? { label: deliveryDate.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' }), value: deliveryDate.toISOString() } : null;
            })
            .filter((date: any) => date !== null);
    }

    groupByDeliveryDate(details: any[]): any[] {
        let deliveryGroup = details.reduce((acc: any, cur: any) => {
            acc[cur.delivery_date] = acc[cur.delivery_date] || { delivery_date: cur.delivery_date, orders: [] };
            acc[cur.delivery_date].orders.push(cur);
            return acc;
        }, {});

        return Object.values(deliveryGroup);
    }

    closeDetails() {
        this.detailsPopUpVisibility = false;
        this.showCancelSubscriptionForm = false;
    }

    getAddonsTotal() {
        let total = 0;
        this.addons.forEach((addon:any) => {
            total += addon.count * parseFloat(addon.supplement.price);
        });
        return Number(total).toFixed(2);
    }

    getOrderStatus(statusId: number) {
        return this.orderStatusList.find((s: any) => s.id === statusId) || {
            color: '#CCCCCC',
            icon: '',
            text: 'Unknown'
        };
    }

    formatDate(dateS: Date) {
        //console.log(dateS);
        let date = new Date(dateS);
        return (date.getDate().toString().length==1 ? ("0"+date.getDate().toString()) : date.getDate().toString()) + "." + ((date.getMonth()+1).toString().length==1 ? ("0"+(date.getMonth()+1).toString()): (date.getMonth()+1).toString()) + "." + date.getFullYear().toString()
    }

    formatDateToDDMMYYYY(dateString: string): string {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }
    

    getStatus(status: number) {
        return this.orderStatusList[status].text;
    }

    @ViewChild(StripeCardComponent) card: StripeCardComponent;
    cardOptions: any = {
        hidePostalCode: true,
        disableLink: true,
        style: {
            base: {
              iconColor: '#666EE8',
              color: '#31325F',
              fontWeight: '300',
              fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
              fontSize: '18px',
              '::placeholder': {
                color: '#CFD7E0',
              },
            },
          },
    };

    elementsOptions: any = {
        locale: 'en-GB',
        appearance: {
            theme: 'flat',
        }
    };

    
    openPayment(item: any) {
        //console.log(item);
        this.to_pay = item;
        this.paymentPopUpVisibility = true;
    }

    openEditWeek(orderId: number, week: number) {
        //console.log(item);
        this.router.navigate(["/edit-week-plan"], { queryParams: {id: orderId, week: week} });
    }

    canEditWeek(order_details: any[], week: number) {
        if(week == 1) return false;
        const weekData = order_details.find((item: any) => item.week === week);
        if(!weekData?.details?.length) return false;
        const deliveryDate = new Date(weekData.details[0].delivery_date);
        deliveryDate.setDate(deliveryDate.getDate() - 2); // meals can be edited until nutrigenic starts the preparation which is 2 day before delivery 
        const now = new Date();
        return now < deliveryDate; 
    }

    openPauseSubscription(id: number){
        this.order = null;
        this.order_details = [];
        this.addons = [];
        this.pauseSubscriptionForm.reset();

        this.order = this.userOrdersResult.data.filter((x:any)=>x.id == id)[0];
        this.order_details = this.order.order_detail.filter((x:any)=>!x.supplement_id);
        this.order_details = Object.values(this.order_details.reduce((acc:any, cur:any) => {
                acc[cur.week] = acc[cur.week] || { week: cur.week, details: []};
                acc[cur.week].details.push(cur);
                return acc;
            }, {}));
        this.loading = false;
        this.createPauseDatesMenu(this.order_details);
        
        this.pauseSubscriptionPopUpVisibility = true;
        
    }

    openDetails(id: number) {
        this.loading = true;
        this.order = null;
        this.order_details = [];
        this.addons = [];
        
        this.userProfileService.getOrderSummaryPriceBreakdown(id).subscribe((response) =>{
            this.order = this.userOrdersResult.data.filter((x:any)=>x.id == id)[0];
            this.order_details = this.order.order_detail.filter((x:any)=>!x.supplement_id);
            this.addons = this.order.order_detail.filter((x:any)=>x.supplement_id);

            this.order_details = Object.values(this.order_details.reduce((acc:any, cur:any) => {
                acc[cur.week] = acc[cur.week] || { week: cur.week, details: []};
                acc[cur.week].details.push(cur);
                return acc;
            }, {}));

            this.order.weekly_prices = response.body.weekly_prices;
            this.createCancelationDatesMenu(this.order_details);
            this.detailsPopUpVisibility = true;
            this.loading = false;
            
        });
        
    }

    closePauseSubscription(){
        this.pauseSubscriptionPopUpVisibility = false;
    }

    pay() {
        if (this.stripeTest.valid) {
            this.spinner.show();
            this.createPaymentIntent(parseFloat(this.to_pay.amount)).pipe(
                switchMap((pi:any) =>
                    this.stripeService.confirmCardPayment(pi.body.client_secret, {
                        payment_method: {
                            card: this.card.element,
                            billing_details: { name: this.stripeTest.get('name')?.value, },
                        },
                    })
                )
            ).subscribe({
                next: (result:any) => {
                    if (result.error) {
                        // Show error to your customer (e.g., insufficient funds)
                        this.spinner.hide();
                        this.handleErrorStripe(result.error.message);
                        //console.log(result.error.message);
                    } else {
                        // The payment has been processed!
                        if (result.paymentIntent.status === 'succeeded') {
                            // Show a success message to your customer
                            let external_order_id = result.paymentIntent.id;
                            this.homeService.repeatOrderPayment({order_id: this.to_pay.order_id, external_order_id: external_order_id, from: 'My Orders'}).subscribe((res: any) => {
                                this.spinner.hide();
                                console.log(res);
                                this.paymentPopUpVisibility = false;
                                localStorage.removeItem('planOrderDetails');
                                localStorage.removeItem('orderDetails');
                                localStorage.removeItem('cart');
                                localStorage.removeItem('addons');
                                localStorage.removeItem('promo_code');
                                localStorage.removeItem('promo_discount');
                                this.handleSuccessResponse('Payment Successful');
                            });
                        } else this.spinner.hide();
                    }
                }, error: (error) => {
                    console.error(error);
                    this.spinner.hide();
                }
            });
        } else if (!this.stripeTest.valid) this.handleErrorFields();
    }

    createPaymentIntent(amount: number): Observable<any> {
        return this.homeService.createPaymentIntent({ amount: amount * 100 });
    }

   

    cancelSubscription() {
        this.showCancelSubscriptionForm = true;
    }

    sendSubscriptionCancelation() {
        if (this.cancellationForm.valid) {
            this.planService.cancelSubscription(this.order.id, this.cancellationForm.get('reason')?.value, this.cancellationForm.get('cancelDate')?.value).subscribe({
                next: () => {
                    this.getUserOrders();
                    this.showCancelSubscriptionForm = false;
                    this.detailsPopUpVisibility = false;
                    this.cancellationForm.reset();
                    this.handleSuccessResponse('Cancelation request sent');
                }, 
                error: (error) => {
                    this.handleError(error);
                }
            });
        }
    }

    sendSubscriptionPause(){
        if (this.pauseSubscriptionForm.valid) {
            this.planService.pauseSubscription(this.order.id, this.pauseSubscriptionForm.get('pauseFromDate')?.value, this.pauseSubscriptionForm.get('pauseToDate')?.value).subscribe({
                next: () => {
                    this.getUserOrders();
                    this.pauseSubscriptionPopUpVisibility = false;
                    this.pauseSubscriptionForm.reset();
                    this.handleSuccessResponse('Pause Subscription applied');
                }, 
                error: (error) => {
                    this.handleError(error);
                }
                
            });
        }
    }


    handleError(error: any): void {
        //console.error('error:', error);
        if(error && error.type && error.type === 'validation'){
            let errors = error.message;
            Object.entries(errors).forEach(([key, value]) => {
                console.log(key, value);
                error = (value as string[])[0];
                Notify.failure(error, {
                    position: 'right-top',
                    timeout: 3000
                });
            });
        } else {
            error = error.message ?? 'Internal error - Could not complete the operation';
                Notify.failure(error, {
                position: 'right-top',
                timeout: 3000
            });
        }
    }

     handleSuccessResponse(message: string = 'Operation Successful'): void {
        this.userOrdersResult.data = [];
        this.getUserOrders();
        Notify.success(message, {
            position: 'right-top',
            timeout: 3000
        });
    }
    handleErrorFields(): void {
        Notify.failure('Insert all required fields', {
            position: 'right-top',
            timeout: 3000
        });
    }
    handleErrorStripe(error: any): void {
        Notify.failure(error, {
            position: 'right-top',
            timeout: 3000
        });
    }


    isSubscriptionValidState(order: any){
        return (this.isSubscriptionActive(order) || order.status == 4 || order.status == 7); // Active, Suspended or Paused
    }


    isSubscriptionActive(order:any){
        return order.status == 5; 
    }

    isSubscriptionFlexi(order:any){
        return order.order_type == 'flexi';
    }

    saveAutoRenew(){
        this.planService.saveAutoRenew(this.order.id, this.order.auto_renew).subscribe({
            next: () => {
                this.getUserOrders();
                this.handleSuccessResponse('Autorenew changed successfully');
            },
            error: (error) => {
                this.order.auto_renew = false;
                this.handleError(error.error);
            }
        });
    }

    editAddress(){
        this.enableEditAddress = true;
    }

    closeEditAddress() {
        this.enableEditAddress = false;
    }


    onAddressSelected(address: Address) {
        //console.log(address);
        this.planService.changeDeliveryAddressForOrder(this.order.id, address).subscribe({
            next: () => {
                this.order.address = address.address;
                this.order.city = address.city;
                this.order.zip = address.zip;
                this.enableEditAddress = false;
                Notify.success('Address changed successfully', {
                    position: 'right-top',
                    timeout: 3000
                });
            },
            error: (error) => {
                this.enableEditAddress = false;
                this.handleError(error.error);
            }
        });
        
    }

}
